import React from 'react';
import { Stack } from '@mui/material';
import ItemInformation from '../PhysicianDashboard/ItemDetails/ItemInformation';
import EnhancedItemInfo from '../PhysicianDashboard/ItemDetails/EnhancedItemInfo';

// A more focused item details component for displaying item information on admin portal without any physician or draft details
function ItemDetails({ item, children }) {

    if (!item) {
        return <Stack p={2}>Select an item to view details</Stack>;
    }

    return (
        <Stack spacing={2} p={2}>
            <ItemInformation item={item} />
            {children && (
                <Stack direction='row' justifyContent='flex-end'>
                    {children}
                </Stack>
            )}
            {/* this component is used on the admin dashboard only. In this case, it does not need a hospitalId to verify the AI feature flag, it can use the user form context */}
            <EnhancedItemInfo item={item} />
        </Stack>
    );

}

export default ItemDetails;